module.exports = __webpack_public_path__ + "static/media/S1N11-5.7db3f5b3.svg";